import {Http} from '../../../Data/config/Http';
import {CreateBrandDTO, UpdateBrandDTO, BrandDTO} from '../models/brand.dto';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

export const ProductBrandAPIDataSource = {
  getBrands: async (): Promise<BrandDTO[]> => {
    try {
      const response = await Http.get<BaseResponse<BrandDTO[]>>(API_ROUTES.PRODUCTS.BRANDS);
      return unwrapResponse(response.data, 'حدث خطأ في جلب البراندات');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  createBrand: async (payload: CreateBrandDTO): Promise<BrandDTO> => {
    try {
      const response = await Http.post<BaseResponse<BrandDTO>>(API_ROUTES.PRODUCTS.BRANDS, payload);
      return unwrapResponse(response.data, 'فشل في إضافة البراند', [200, 201]);
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  updateBrand: async (id: number, payload: UpdateBrandDTO): Promise<BrandDTO> => {
    try {
      const response = await Http.put<BaseResponse<BrandDTO>>(API_ROUTES.PRODUCTS.BRAND_BY_ID(id.toString()), payload);
      return unwrapResponse(response.data, 'فشل في تعديل البراند');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  deleteBrand: async (id: number): Promise<void> => {
    try {
      const response = await Http.delete<BaseResponse<void>>(API_ROUTES.PRODUCTS.BRAND_BY_ID(id.toString()));
      unwrapResponse(response.data, 'فشل في حذف البراند', [200, 204]);
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};

